module.exports = __webpack_public_path__ + "img/自由主题.b1ef43ea.png";